/// <amd-module name="Release/Commands/Dialogs/RenamePipelineDialog" />
import * as React from "react";

import { Dialog } from "VSSUI/Dialog";
import { TextField, TextFieldWithMessage } from "VSSUI/TextField";

import { VssComponent, IVssComponentProperties, IVssComponentContext, Components } from "VSS/Platform/Layout";

import * as Resources from "Release/Commands/Dialogs/Resources";

export interface IRenamePipelineDialogProps extends IVssComponentProperties {
    parentPath: string;
    initialName: string;
    onPipelineRenamed: (newPipelineName: string) => void;
    onClose: () => any;
}

interface IRenamePipelineDialogState {
    name: string;
    nameErrorMessage: string;
}

export class RenamePipelineDialog extends VssComponent<IRenamePipelineDialogProps, IRenamePipelineDialogState>{

    constructor(props: IRenamePipelineDialogProps) {
        super(props);

        this.state = {
            name: this.props.initialName,
            nameErrorMessage: ""
        };
    }

    public render(): React.ReactNode {
        return (
            <Dialog
                titleProps={{ text: Resources.RenamePipelineDialogTitle }}
                onDismiss={this._onDialogClose}
                defaultActiveElement=".def-name-input"
                escDismiss={true}
                calloutContentClassName="release-command-dialog"
                footerButtonProps={[
                    {
                        onClick: this._onDialogClose,
                        text: Resources.Cancel
                    },
                    {
                        onClick: this._onOkClick,
                        disabled: !!this.state.nameErrorMessage || this.props.initialName === this.state.name,
                        primary: true,
                        text: Resources.Ok
                    }
                ]}>
                <TextFieldWithMessage
                    textFieldProps={{
                        label: Resources.NameLabel,
                        value: this.state.name,
                        inputClassName: "def-name-input",
                        onChange: this._onNameChanged
                    }}
                    message={this.state.nameErrorMessage} />
                <TextField
                    className="folder-text-field"
                    label={Resources.FolderPathTextboxLabel}
                    value={this.props.parentPath}
                    disabled={true} />
            </Dialog>
        );
    }

    private _onNameChanged = (event: React.ChangeEvent<HTMLInputElement>, newValue: string): void => {
        let errorMessage = "";
        if (!newValue) {
            errorMessage = Resources.CannotBeEmptyErrorMessage;
        }

        this.setState({
            name: newValue,
            nameErrorMessage: errorMessage
        });
    }

    private _closeDialog() {
        if (!!this.props.onClose) {
            this.props.onClose();
        }
    }

    private _onDialogClose = (): void => {
        this._closeDialog();
    }

    private _onOkClick = (): void => {
        this.props.onClose();

        if (this.props.onPipelineRenamed) {
            this.props.onPipelineRenamed(this.state.name.trim());
        }
    }
}

Components.add("rename-rd-dialog", RenamePipelineDialog);